import PropTypes from "prop-types"
import React, { useState } from "react"

import { useTracker } from "src/hooks/use_tracker"

import GuestCreateAccountWelcome, {
  createAccountOfferPropType,
} from "./GuestCreateAccountWelcome"
import GuestSignInNudge from "./GuestSignInNudge"
import SignContractWizardContainer from "./SignContractWizardContainer"

const skipStorageKey = (quote, signInAvailable) =>
  signInAvailable
    ? `signContractNudgeSkipped:${quote.encodedId}`
    : `signContractCreateAccountSkipped:${quote.encodedId}`

const readSkipped = (key) => {
  try {
    return sessionStorage.getItem(key) === "true"
  } catch (error) {
    console.error(error)
    return false
  }
}

const SignContractEntry = (props) => {
  const {
    authPhotoUrl,
    contact,
    createAccountOffer,
    marina,
    quote,
    signInAvailable = false,
    signInUrl,
  } = props
  const storageKey = skipStorageKey(quote, signInAvailable)
  const [skipped, setSkipped] = useState(() => readSkipped(storageKey))
  const tracker = useTracker()

  const track = (eventName) =>
    tracker.trackEvent(eventName, {
      contract_quote_id: quote.id,
      marina_id: marina.id,
      marina_name: marina.name,
    })

  const handleSignIn = () => track("contracts_v2:sign_in_nudge_accepted")

  const handleCreateAccount = () =>
    track("contracts_v2:create_account_offer_accepted")

  const skip = (eventName) => {
    track(eventName)
    try {
      sessionStorage.setItem(storageKey, "true")
    } catch (error) {
      console.error(error)
    }
    setSkipped(true)
  }

  if (signInAvailable && !skipped) {
    return (
      <GuestSignInNudge
        authPhotoUrl={authPhotoUrl}
        contact={contact}
        onSignIn={handleSignIn}
        onSkip={() => skip("contracts_v2:sign_in_nudge_skipped")}
        signInUrl={signInUrl}
      />
    )
  }

  if (createAccountOffer && !skipped) {
    return (
      <GuestCreateAccountWelcome
        authPhotoUrl={authPhotoUrl}
        offer={createAccountOffer}
        onCreateAccount={handleCreateAccount}
        onSkip={() => skip("contracts_v2:create_account_offer_skipped")}
      />
    )
  }

  return <SignContractWizardContainer {...props} />
}

SignContractEntry.propTypes = {
  authPhotoUrl: PropTypes.string,
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  createAccountOffer: createAccountOfferPropType,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,
  quote: PropTypes.shape({
    id: PropTypes.number,
    encodedId: PropTypes.string.isRequired,
  }).isRequired,
  signInAvailable: PropTypes.bool,
  signInUrl: PropTypes.string,
}

export default SignContractEntry
